import { render, staticRenderFns } from "./translationSettingsDialog.vue?vue&type=template&id=6842417a&scoped=true&"
import script from "./translationSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./translationSettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./translationSettingsDialog.vue?vue&type=style&index=0&id=6842417a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6842417a",
  null
  
)

export default component.exports